import { useState, useCallback } from "react";

import CatalogServices from "./../services/CatalogServices";

export function useSchools() {
    const [schools, setSchools] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchSchools = useCallback(async () => {
        setLoading(true);
        try {
            setSchools([]);
            const response = await CatalogServices.getSchools();
            if (!response.success) return;
            const schools = response?.data?.map(item => ({ id: item.id_plantel, data: item.nombre_plantel }));
            setSchools(schools);
        } catch (error) {
            console.error("Error fetching schools:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchSchoolsWithAllOption = useCallback(async () => {
        setLoading(true);
        try {
            setSchools([]);
            const response = await CatalogServices.getSchools();
            if (!response.success) return;
            const schools = response?.data?.map(item => ({ id: item.id_plantel, data: item.nombre_plantel }));
            setSchools([{ id: '-1', data: 'Todos' }, ...schools]);
        } catch (error) {
            console.error("Error fetching schools:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchMySchools = useCallback(async (includeAll = true) => {
        setLoading(true);
        try {
            setSchools([]);
            const response = await CatalogServices.fetchMySchools();
            if (!response.success) return;
            
            var schools = response?.data?.map(item => ({
                id: item.id_plantel,
                data: item.nombre_plantel
            })) || [];

            if (includeAll && schools.length > 1) {
                schools = [{ id: '-1', data: 'Todos' }, ...schools];
            }
            setSchools(schools);
        } catch (error) {
            console.error("Error fetching schools:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        schoolsList: schools,
        loading,
        fetchSchools,
        fetchSchoolsWithAllOption,
        fetchMySchools
    };
}
